import formTagManagerMain from './formTagManagerMain';
import formTagManagerExtendedInfo from './formTagManagerExtendedInfo';
import formTagManagerPoster from './formTagManagerPoster';

export default {
  title: 'Tag Manager',
  attributeName: 'tagmanager',
  getURL: 'tagmanager',
  createURL: 'tagmanager',
  updateURL: 'tagmanager',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: true,
  idAttribute: 'id',
  sessionParams: [],
  formConfig: [formTagManagerMain,formTagManagerPoster,formTagManagerExtendedInfo],
  noArea: true,
  goBack: true,
};
